import {useRef, useState} from 'react'
import {v4 as uuid} from 'uuid'
import {bankRequest} from '../reconciliationApi'

/** Dismissal uses the existing review state; it never reclassifies bank evidence. */
export function useBankDismissal() {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [lastDismissal, setLastDismissal] = useState<{ids: string[]; reviewId: string} | null>(null)
  const inFlight = useRef(false)
  const intent = useRef<{key: string; requestId: string} | null>(null)
  const dismiss = async (ids: string[]) => {
    if (inFlight.current || !ids.length) return false
    inFlight.current = true
    setBusy(true)
    setError('')
    const key = [...ids].sort().join(',')
    if (intent.current?.key !== key) intent.current = {key, requestId: uuid()}
    const requestId = intent.current!.requestId
    try {
      await bankRequest('review', {transactionIds: ids, dismiss: true, requestId})
      setLastDismissal({ids, reviewId: requestId})
      intent.current = null
      return true
    } catch (e: any) {
      setError(e.message || 'Could not dismiss transactions. Try again.')
      return false
    } finally {
      inFlight.current = false
      setBusy(false)
    }
  }
  const undo = async () => {
    if (inFlight.current || !lastDismissal) return
    inFlight.current = true
    setBusy(true)
    setError('')
    try {
      await bankRequest('review', {
        transactionIds: lastDismissal.ids,
        clear: true,
        reviewId: lastDismissal.reviewId,
      })
      setLastDismissal(null)
      intent.current = null
    } catch (e: any) {
      setError(e.message || 'Could not undo dismissal. Open the transaction to review it.')
    } finally {
      inFlight.current = false
      setBusy(false)
    }
  }
  return {busy, error, lastDismissal, dismiss, undo}
}
